// Fuente única de la versión visible de Prikly (login + menú lateral).
// Subir en cada release a QA/main: PATCH=fix, MINOR=feature, MAJOR=incompatible.
// MINOR y PATCH van de 0 a 99; al superar 99 hacen carry (v1.99.99 -> v2.0.0).
export const APP_VERSION = "v2.22.6-uat";
